/**
 * Hook para salvar e restaurar o estado do catálogo
 * Permite que o usuário volte exatamente para onde estava após ver detalhes de um produto
 */

const STORAGE_KEY = 'catalog_state';

export const saveCatalogState = (catalogType, state) => {
    try {
        const savedState = {
            catalogType,
            ...state,
            scrollY: window.scrollY,
            timestamp: Date.now()
        };
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(savedState));
    } catch (e) {
        console.warn('Erro ao salvar estado do catálogo:', e);
    }
};

export const getCatalogState = (catalogType) => {
    try {
        const saved = sessionStorage.getItem(STORAGE_KEY);
        if (!saved) return null;

        const state = JSON.parse(saved);

        // Verificar se é o mesmo tipo de catálogo
        if (state.catalogType !== catalogType) return null;

        // Verificar se não expirou (30 minutos)
        const MAX_AGE = 30 * 60 * 1000;
        if (Date.now() - state.timestamp > MAX_AGE) {
            sessionStorage.removeItem(STORAGE_KEY);
            return null;
        }

        return state;
    } catch (e) {
        console.warn('Erro ao restaurar estado do catálogo:', e);
        return null;
    }
};

export const clearCatalogState = () => {
    sessionStorage.removeItem(STORAGE_KEY);
};

export default { saveCatalogState, getCatalogState, clearCatalogState };
